@if (errorType === ErrorType.SAVE_GENERIC_ERROR) {

    <pf-hinweisbox [boxType]="HinweisboxTypeEnum.ERROR" [boxTitle]="'sendmail.form.draft-not-saved' | i18next"
                   boxId="draft-store-error">
        {{ 'sendmail.form.draft-save-error' | i18next }}
        <ul>
            <li>{{ 'sendmail.form.draft-save-retry' | i18next }}</li>
            <li>{{ 'sendmail.form.draft-copy-alt' | i18next }}</li>
        </ul>
    </pf-hinweisbox>

} @else if (errorType === ErrorType.SEND_GENERIC_ERROR) {

    <pf-hinweisbox [boxType]="HinweisboxTypeEnum.ERROR" [boxTitle]="'sendmail.form.msg-not-sent' | i18next"
                   boxId="nachricht-send-error">
        {{ 'sendmail.form.msg-send-error' | i18next }}
        <ul>
            <li> {{ 'sendmail.form.msg-send-retry' | i18next }}</li>
            <li> {{ 'sendmail.form.msg-send-later-via-draft' | i18next }}</li>
        </ul>
    </pf-hinweisbox>

} @else if (errorType === ErrorType.SAVE_VALIDATION_ERROR) {

    <pf-hinweisbox [boxType]="HinweisboxTypeEnum.ERROR" [boxTitle]="'sendmail.form.draft-invalid' | i18next"
                   boxId="nachricht-validation-error">
        {{ validationErrorText }}
    </pf-hinweisbox>

} @else if (errorType === ErrorType.SEND_VALIDATION_ERROR) {

    <pf-hinweisbox [boxType]="HinweisboxTypeEnum.ERROR" [boxTitle]="'sendmail.form.msg-invalid' | i18next"
                   boxId="nachricht-validation-error">
        {{ validationErrorText }}
    </pf-hinweisbox>

}